// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer.has-cards {
  overflow: hidden;
  padding-top: 500px;
  margin-top: -420px;
  position: relative;
  background: 0 0;
  pointer-events: none;
}

.footer {
  display: flex;
  align-items: center;
  background: #f4f5f7;
  padding: 1rem 0;
  box-shadow: 0 -1px 1rem rgba(0, 0, 0, 0.15) !important;
  height: 70px;
}

.footer .nav .nav-item .nav-link {
  color: #4e5255 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/footer/footer.component.scss"],"names":[],"mappings":"AAYA;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AAXJ;;AAaA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,sDAAA;EACA,YAAA;AAVJ;;AAaA;EACI,yBAAA;AAVJ","sourcesContent":[".footer {\r\n    // content: \"\";\r\n    // position: absolute;\r\n    // left: 0;\r\n    // right: 0;\r\n    // // top: 600px;\r\n    // height: 400px;\r\n    // background: #f4f5f7;\r\n    // -webkit-transform: skew(0,-3deg);\r\n    // transform: skew(0,-3deg);\r\n}\r\n\r\n.footer.has-cards {\r\n    overflow: hidden;\r\n    padding-top: 500px;\r\n    margin-top: -420px;\r\n    position: relative;\r\n    background: 0 0;\r\n    pointer-events: none;\r\n}\r\n.footer {\r\n    display: flex; \r\n    align-items: center;\r\n    background: #f4f5f7;\r\n    padding: 1rem 0;\r\n    box-shadow: 0 -1px 1rem rgba(0, 0, 0, 0.15) !important;\r\n    height: 70px;\r\n}\r\n\r\n.footer .nav .nav-item .nav-link {\r\n    color: #4e5255 !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
